import React, { Component } from "react";

 
class Home extends Component {
  render() {
    return (
      <div>
          
          <img src="Website_Splash.png" alt="About Dash" id="splash_image"/>
      
      </div>
    );
  }
}
 
export default Home;
